import { render, staticRenderFns } from "./enterprisePracticeResource.vue?vue&type=template&id=58c66b3e&"
import script from "./enterprisePracticeResource.vue?vue&type=script&lang=js&"
export * from "./enterprisePracticeResource.vue?vue&type=script&lang=js&"
import style0 from "./enterprisePracticeResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports